import { Component, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'
import { ViewService } from '../../shared/view.service'
import { fade, popUp } from '../../shared/animations'

@Component({
    selector: 'result-info',
    template: require('./result-info.component.html'),
    styles: [require('./result-info.component.scss')],
    animations: [fade, popUp]
})

export class ResultInfoComponent implements OnDestroy, OnInit {
    private show = false;
    private resultInfo: Object = null;
    private subscription: Subscription = null;
    constructor(private _viewService: ViewService) {}

    ngOnInit() {
        this.subscription = this._viewService.getResult().subscribe(info => this.update(info));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    get stateName() {
        return this.show ? 'show' : 'hide';
    }

    update(info: Object) {
        if (!this.show) {
            this.toggle();
        }
        this.resultInfo = info;
    }

    private toggle(): void {
        this.show = !this.show;
    }
}
